var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 20",
    style: {
      enableBackground: "new 0 0 22 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8,2.3c-1.1-1.1-2.6-1.8-4.1-1.8c0,0,0,0,0,0c-1.9,0-3.6,0.9-4.7,2.5C9.6,1,7.2,0.1,4.9,0.7 c-2.6,0.7-4.4,3-4.4,5.8c0,2.8,1.5,5.7,4.3,8.4c1.8,1.7,3.8,3.2,5.9,4.5l0.3,0.2l0.3-0.2c2.1-1.3,4.1-2.8,5.9-4.5 c2.9-2.8,4.3-5.5,4.3-8.4C21.5,4.9,20.9,3.4,19.8,2.3z M16.5,14.2c-1.7,1.5-3.6,3-5.5,4.2c-1.9-1.2-3.8-2.7-5.5-4.2 c-2.7-2.6-4-5.2-4-7.7c0-2.3,1.5-4.3,3.7-4.8c0.4-0.1,0.8-0.1,1.1-0.1c1.8,0,3.4,1,4.2,2.7L11,5l0.4-0.9c0.8-1.6,2.5-2.7,4.2-2.7h0 c0,0,0,0,0,0C17,1.5,18.2,2,19.1,3c0.9,0.9,1.4,2.2,1.4,3.5C20.5,9.2,19.2,11.6,16.5,14.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/heart2.f53e68202086dfe32c89eda1d806fea2.svg";
export { ForwardRef as ReactComponent };